import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../lib/LanguageContext';
type PageType = 'home' | 'fitur' | 'kontak';
interface SEOProps {
  page?: PageType;
}
const OG_IMAGE = 'https://cdn.magicpatterns.com/uploads/rpHNegJhi9AbiPSYST2Gsx/Screenshot_2026-02-18_at_03-04-11_HT_Group_App.png';
const OG_IMAGE_ALT = {
  id: 'sawit-net Dashboard — Sistem Manajemen Pabrik Kelapa Sawit (PKS) Terintegrasi',
  en: 'sawit-net Dashboard — Integrated Palm Oil Mill (PKS) Management Platform'
};
const SEO_DATA: Record<PageType, Record<'id' | 'en', {
  title: string;
  description: string;
  keywords: string;
  ogUrl: string;
  canonical: string;
  ogLocale: string;
  hreflangSelf: string;
  hreflangAlt: string;
  hreflangAltUrl: string;
  ogType: string;
}>> = {
  home: {
    id: {
      title: 'Software Pabrik Kelapa Sawit (PKS) Terintegrasi | sawit-net',
      description: 'Software pabrik kelapa sawit (PKS) terintegrasi: timbangan digital, grading TBS, monitoring CPO, payroll & keuangan dalam satu platform real-time. Konsultasi gratis.',
      keywords: 'software pabrik kelapa sawit, software PKS, sistem manajemen PKS, aplikasi PKS, ERP kelapa sawit, ERP sawit, digitalisasi pabrik sawit, sistem timbangan digital sawit, software grading TBS, monitoring CPO real-time, sistem informasi pabrik sawit, smart mill indonesia, mill 4.0, sawit-net, netkrida',
      ogUrl: 'https://sawit-net.com/id',
      canonical: 'https://sawit-net.com/id',
      ogLocale: 'id_ID',
      hreflangSelf: 'id',
      hreflangAlt: 'en',
      hreflangAltUrl: 'https://sawit-net.com/en',
      ogType: 'website'
    },
    en: {
      title: 'Palm Oil Mill Software & ERP Platform | sawit-net',
      description: 'End-to-end palm oil mill software: digital weighbridge, FFB grading, CPO monitoring, payroll & finance in one real-time ERP platform. Book a free consultation.',
      keywords: 'palm oil mill software, palm oil ERP, palm oil mill management system, palm oil mill SaaS, FFB grading software, CPO monitoring software, digital weighbridge palm oil, smart palm oil mill, palm oil mill automation, mill 4.0 software, mill management platform indonesia, sawit-net, netkrida',
      ogUrl: 'https://sawit-net.com/en',
      canonical: 'https://sawit-net.com/en',
      ogLocale: 'en_US',
      hreflangSelf: 'en',
      hreflangAlt: 'id',
      hreflangAltUrl: 'https://sawit-net.com/id',
      ogType: 'website'
    }
  },
  fitur: {
    id: {
      title: '9 Modul Software PKS — Fitur Lengkap | sawit-net',
      description: 'Jelajahi 9 modul sawit-net: Dashboard, Supply Chain, Produksi, Gudang, Pemasaran, Payroll, Absensi, Keuangan & Master Data. Software PKS terintegrasi real-time.',
      keywords: 'fitur sawit-net, modul software PKS, dashboard pabrik sawit, supply chain sawit, monitoring produksi CPO, payroll pabrik sawit, keuangan PKS, gudang inventaris sawit, absensi karyawan pabrik, master data PKS, sistem ERP sawit, aplikasi mill sawit',
      ogUrl: 'https://sawit-net.com/id/fitur',
      canonical: 'https://sawit-net.com/id/fitur',
      ogLocale: 'id_ID',
      hreflangSelf: 'id',
      hreflangAlt: 'en',
      hreflangAltUrl: 'https://sawit-net.com/en/fitur',
      ogType: 'website'
    },
    en: {
      title: '9 Palm Oil Mill Software Modules — Features | sawit-net',
      description: 'Explore 9 sawit-net modules: Dashboard, Supply Chain, Production, Warehouse, Marketing, Payroll, Attendance, Finance & Master Data. Integrated real-time mill software.',
      keywords: 'sawit-net features, palm oil mill software modules, mill dashboard software, supply chain palm oil, CPO production monitoring, mill payroll software, finance software PKS, warehouse inventory mill, employee attendance mill, master data palm oil ERP',
      ogUrl: 'https://sawit-net.com/en/fitur',
      canonical: 'https://sawit-net.com/en/fitur',
      ogLocale: 'en_US',
      hreflangSelf: 'en',
      hreflangAlt: 'id',
      hreflangAltUrl: 'https://sawit-net.com/id/fitur',
      ogType: 'website'
    }
  },
  kontak: {
    id: {
      title: 'Hubungi Kami — Konsultasi Software PKS | sawit-net',
      description: 'Konsultasi gratis transformasi digital pabrik kelapa sawit Anda. Hubungi tim sawit-net via WhatsApp, email, atau kunjungi kantor kami di Pekanbaru, Riau.',
      keywords: 'kontak sawit-net, konsultasi software PKS, hubungi netkrida, demo software pabrik sawit, implementasi sistem PKS, vendor software sawit pekanbaru, layanan netkrida, layanan@netkrida.co.id',
      ogUrl: 'https://sawit-net.com/id/kontak',
      canonical: 'https://sawit-net.com/id/kontak',
      ogLocale: 'id_ID',
      hreflangSelf: 'id',
      hreflangAlt: 'en',
      hreflangAltUrl: 'https://sawit-net.com/en/kontak',
      ogType: 'website'
    },
    en: {
      title: 'Contact Us — Palm Oil Mill Software Demo | sawit-net',
      description: 'Free consultation for your palm oil mill digital transformation. Contact the sawit-net team via WhatsApp, email, or visit our office in Pekanbaru, Riau, Indonesia.',
      keywords: 'contact sawit-net, palm oil mill software consultation, netkrida contact, sawit-net demo, palm oil mill system implementation, palm oil software vendor indonesia, layanan@netkrida.co.id',
      ogUrl: 'https://sawit-net.com/en/kontak',
      canonical: 'https://sawit-net.com/en/kontak',
      ogLocale: 'en_US',
      hreflangSelf: 'en',
      hreflangAlt: 'id',
      hreflangAltUrl: 'https://sawit-net.com/id/kontak',
      ogType: 'website'
    }
  }
};
function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function setLink(rel: string, href: string, extra?: Record<string, string>) {
  let selector = `link[rel="${rel}"]`;
  if (extra?.hreflang) selector += `[hreflang="${extra.hreflang}"]`;else if (rel === 'canonical') selector = `link[rel="canonical"]`;
  let el = document.querySelector(selector) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (extra) Object.entries(extra).forEach(([k, v]) => el!.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}
function setJsonLd(id: string, data: object) {
  let el = document.querySelector(`script[data-id="${id}"]`) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.setAttribute('type', 'application/ld+json');
    el.setAttribute('data-id', id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data, null, 2);
}
function removeJsonLd(id: string) {
  const el = document.querySelector(`script[data-id="${id}"]`);
  if (el) el.remove();
}
export function SEO({
  page = 'home'
}: SEOProps) {
  const {
    lang
  } = useLanguage();
  const seo = SEO_DATA[page][lang as 'id' | 'en'];
  useEffect(() => {
    // --- HTML lang ---
    document.documentElement.lang = lang === 'id' ? 'id' : 'en';
    document.documentElement.setAttribute('dir', 'ltr');
    // --- Title ---
    document.title = seo.title;
    // --- Basic Meta ---
    setMeta('description', seo.description);
    setMeta('keywords', seo.keywords);
    setMeta('robots', 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');
    setMeta('googlebot', 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');
    setMeta('bingbot', 'index, follow');
    setMeta('author', 'PT Netkrida Tuah Cakrawala');
    setMeta('publisher', 'PT Netkrida Tuah Cakrawala');
    setMeta('viewport', 'width=device-width, initial-scale=1.0');
    setMeta('theme-color', '#0F3D2E');
    setMeta('color-scheme', 'light');
    setMeta('language', lang === 'id' ? 'Indonesian' : 'English');
    setMeta('referrer', 'strict-origin-when-cross-origin');
    setMeta('format-detection', 'telephone=yes, email=yes, address=yes');
    // --- Mobile / App ---
    setMeta('application-name', 'sawit-net');
    setMeta('apple-mobile-web-app-title', 'sawit-net');
    setMeta('apple-mobile-web-app-capable', 'yes');
    setMeta('apple-mobile-web-app-status-bar-style', 'default');
    setMeta('mobile-web-app-capable', 'yes');
    // --- Search Console Verification ---
    // TODO: Replace with real codes from Google Search Console & Bing Webmaster Tools before launch
    // setMeta('google-site-verification', 'YOUR_CODE_HERE')
    // setMeta('msvalidate.01', 'YOUR_CODE_HERE')
    // --- Geo / Local SEO ---
    setMeta('geo.region', 'ID-RI');
    setMeta('geo.placename', 'Pekanbaru, Riau, Indonesia');
    setMeta('geo.position', '0.4798741;101.4313303');
    setMeta('ICBM', '0.4798741, 101.4313303');
    // --- Open Graph ---
    setMeta('og:type', seo.ogType, 'property');
    setMeta('og:title', seo.title, 'property');
    setMeta('og:description', seo.description, 'property');
    setMeta('og:url', seo.ogUrl, 'property');
    setMeta('og:locale', seo.ogLocale, 'property');
    setMeta('og:locale:alternate', lang === 'id' ? 'en_US' : 'id_ID', 'property');
    setMeta('og:site_name', 'sawit-net by Netkrida', 'property');
    setMeta('og:image', OG_IMAGE, 'property');
    setMeta('og:image:secure_url', OG_IMAGE, 'property');
    setMeta('og:image:width', '1200', 'property');
    setMeta('og:image:height', '630', 'property');
    setMeta('og:image:type', 'image/png', 'property');
    setMeta('og:image:alt', OG_IMAGE_ALT[lang as 'id' | 'en'], 'property');
    // --- Twitter / X Card ---
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', seo.title);
    setMeta('twitter:description', seo.description);
    setMeta('twitter:image', OG_IMAGE);
    setMeta('twitter:image:alt', OG_IMAGE_ALT[lang as 'id' | 'en']);
    setMeta('twitter:site', '@sawitnet');
    setMeta('twitter:creator', '@sawitnet');
    setMeta('twitter:domain', 'sawit-net.com');
    // --- Canonical & hreflang ---
    setLink('canonical', seo.canonical);
    setLink('alternate', seo.canonical, {
      hreflang: seo.hreflangSelf
    });
    setLink('alternate', seo.hreflangAltUrl, {
      hreflang: seo.hreflangAlt
    });
    setLink('alternate', 'https://sawit-net.com/id', {
      hreflang: 'x-default'
    });
    setLink('sitemap', 'https://sawit-net.com/sitemap.xml');
    // --- JSON-LD: Organization (all pages) ---
    setJsonLd('organization', {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      '@id': 'https://sawit-net.com/#organization',
      name: 'PT Netkrida Tuah Cakrawala',
      alternateName: ['Netkrida', 'sawit-net'],
      url: 'https://sawit-net.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://sawit-net.com/logo.png',
        width: 200,
        height: 60
      },
      sameAs: ['https://www.linkedin.com/company/netkrida', 'https://www.instagram.com/netkrida', 'https://www.facebook.com/netkrida', 'https://www.netkrida.co.id'],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'sales',
        email: 'layanan@netkrida.co.id',
        areaServed: 'ID',
        availableLanguage: ['Indonesian', 'English']
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Savana Cluster, A2, Jl. Karya Bakti',
        addressLocality: 'Pekanbaru',
        addressRegion: 'Riau',
        postalCode: '28282',
        addressCountry: 'ID'
      }
    });
    // --- JSON-LD: WebSite (all pages) ---
    setJsonLd('website', {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': 'https://sawit-net.com/#website',
      name: 'sawit-net',
      alternateName: 'sawit-net by Netkrida',
      url: 'https://sawit-net.com',
      inLanguage: ['id-ID', 'en-US'],
      publisher: {
        '@id': 'https://sawit-net.com/#organization'
      }
    });
    // --- Page-specific JSON-LD ---
    if (page === 'home') {
      setJsonLd('software', {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'sawit-net',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web, iOS, Android',
        url: 'https://sawit-net.com',
        inLanguage: lang === 'id' ? 'id-ID' : 'en-US',
        description: lang === 'id' ? 'Software pabrik kelapa sawit (PKS) terintegrasi end-to-end untuk meningkatkan efisiensi, transparansi, dan profitabilitas operasional mill.' : 'End-to-end palm oil mill software to boost mill efficiency, transparency, and profitability across operations.',
        provider: {
          '@id': 'https://sawit-net.com/#organization'
        },
        featureList: lang === 'id' ? ['Timbangan Digital', 'Sistem Grading TBS', 'Sistem Anti-Fraud', 'Monitoring Tangki CPO', 'Monitoring Produksi', 'SDM & Payroll', 'Integrasi ERP', 'Dukungan Sensor IoT', 'Dashboard Real-time', 'Manajemen Multi-Pabrik'] : ['Digital Weighbridge', 'FFB Grading System', 'Anti-Fraud System', 'CPO Tank Monitoring', 'Production Monitoring', 'HR & Payroll', 'ERP Integration', 'IoT Sensor Support', 'Real-time Dashboard', 'Multi-plant Management'],
        screenshot: OG_IMAGE
      });
      setJsonLd('webpage', {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${seo.canonical}#webpage`,
        name: seo.title,
        description: seo.description,
        url: seo.canonical,
        inLanguage: lang === 'id' ? 'id-ID' : 'en-US',
        isPartOf: {
          '@id': 'https://sawit-net.com/#website'
        },
        about: {
          '@id': 'https://sawit-net.com/#organization'
        },
        primaryImageOfPage: {
          '@type': 'ImageObject',
          url: OG_IMAGE,
          width: 1200,
          height: 630
        }
      });
      setJsonLd('breadcrumb', {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          name: lang === 'id' ? 'Beranda' : 'Home',
          item: seo.canonical
        }]
      });
      setJsonLd('faq', {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        inLanguage: lang === 'id' ? 'id-ID' : 'en-US',
        mainEntity: lang === 'id' ? [{
          '@type': 'Question',
          name: 'Apa itu sawit-net?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'sawit-net adalah software pabrik kelapa sawit (PKS) terintegrasi end-to-end yang mencakup seluruh proses dari penerimaan TBS, grading, timbangan digital, produksi, hingga pengiriman CPO. Dikembangkan oleh PT Netkrida Tuah Cakrawala.'
          }
        }, {
          '@type': 'Question',
          name: 'Berapa biaya menggunakan sawit-net?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'sawit-net menggunakan model harga enterprise yang disesuaikan dengan kebutuhan dan skala operasional pabrik Anda. Hubungi tim kami melalui layanan@netkrida.co.id untuk informasi harga.'
          }
        }, {
          '@type': 'Question',
          name: 'Apakah sawit-net bisa diintegrasikan dengan sistem ERP yang sudah ada?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ya, sawit-net mendukung integrasi dengan SAP, Oracle, Microsoft Dynamics, dan sistem ERP lainnya melalui Open API Architecture.'
          }
        }, {
          '@type': 'Question',
          name: 'Berapa lama implementasi sawit-net?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Implementasi sawit-net umumnya membutuhkan 7–14 hari kerja, didampingi tim onboarding berpengalaman dari Netkrida.'
          }
        }, {
          '@type': 'Question',
          name: 'Apakah sawit-net cocok untuk pabrik kelapa sawit skala kecil?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ya, sawit-net dirancang modular dan dapat diimplementasikan baik untuk PKS skala kecil, menengah, hingga grup multi-pabrik dengan kebutuhan kompleks.'
          }
        }] : [{
          '@type': 'Question',
          name: 'What is sawit-net?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'sawit-net is an end-to-end palm oil mill software platform developed by PT Netkrida Tuah Cakrawala, covering FFB receiving, grading, digital weighbridge, production, and CPO dispatch.'
          }
        }, {
          '@type': 'Question',
          name: 'How much does sawit-net cost?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "sawit-net uses an enterprise pricing model tailored to your mill's operational scale and needs. Contact our team at layanan@netkrida.co.id for pricing information."
          }
        }, {
          '@type': 'Question',
          name: 'Can sawit-net integrate with existing ERP systems?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, sawit-net supports integration with SAP, Oracle, Microsoft Dynamics, and other ERP systems through its Open API Architecture.'
          }
        }, {
          '@type': 'Question',
          name: 'How long does sawit-net implementation take?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'sawit-net implementation typically takes 7–14 business days, supported by an experienced onboarding team from Netkrida.'
          }
        }, {
          '@type': 'Question',
          name: 'Is sawit-net suitable for small-scale palm oil mills?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, sawit-net is modular and can be deployed for small, medium, or large multi-mill groups with complex enterprise requirements.'
          }
        }]
      });
      removeJsonLd('contactpage');
      removeJsonLd('itemlist');
    }
    if (page === 'fitur') {
      removeJsonLd('software');
      removeJsonLd('faq');
      removeJsonLd('contactpage');
      setJsonLd('webpage', {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${seo.canonical}#webpage`,
        name: seo.title,
        description: seo.description,
        url: seo.canonical,
        inLanguage: lang === 'id' ? 'id-ID' : 'en-US',
        isPartOf: {
          '@id': 'https://sawit-net.com/#website'
        },
        about: {
          '@id': 'https://sawit-net.com/#organization'
        }
      });
      setJsonLd('breadcrumb', {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          name: lang === 'id' ? 'Beranda' : 'Home',
          item: lang === 'id' ? 'https://sawit-net.com/id' : 'https://sawit-net.com/en'
        }, {
          '@type': 'ListItem',
          position: 2,
          name: lang === 'id' ? 'Fitur' : 'Features',
          item: seo.canonical
        }]
      });
      setJsonLd('itemlist', {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: lang === 'id' ? 'Modul sawit-net' : 'sawit-net Modules',
        description: seo.description,
        url: seo.canonical,
        numberOfItems: 9,
        itemListElement: (lang === 'id' ? ['Dashboard', 'Master Data', 'Supply Chain', 'Produksi', 'Gudang', 'Pemasaran', 'Payroll & SDM', 'Absensi', 'Keuangan'] : ['Dashboard', 'Master Data', 'Supply Chain', 'Production', 'Warehouse', 'Marketing', 'Payroll & HR', 'Attendance', 'Finance']).map((name, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name,
          url: `${seo.canonical}#${['dashboard', 'master-data', 'supply-chain', 'produksi', 'gudang', 'pemasaran', 'payroll', 'absensi', 'keuangan'][i]}`
        }))
      });
    }
    if (page === 'kontak') {
      removeJsonLd('software');
      removeJsonLd('faq');
      removeJsonLd('itemlist');
      setJsonLd('webpage', {
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        '@id': `${seo.canonical}#webpage`,
        name: seo.title,
        description: seo.description,
        url: seo.canonical,
        inLanguage: lang === 'id' ? 'id-ID' : 'en-US',
        isPartOf: {
          '@id': 'https://sawit-net.com/#website'
        },
        about: {
          '@id': 'https://sawit-net.com/#organization'
        }
      });
      setJsonLd('breadcrumb', {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          name: lang === 'id' ? 'Beranda' : 'Home',
          item: lang === 'id' ? 'https://sawit-net.com/id' : 'https://sawit-net.com/en'
        }, {
          '@type': 'ListItem',
          position: 2,
          name: lang === 'id' ? 'Kontak' : 'Contact',
          item: seo.canonical
        }]
      });
      setJsonLd('contactpage', {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        '@id': 'https://sawit-net.com/#localbusiness',
        name: 'PT Netkrida Tuah Cakrawala',
        image: OG_IMAGE,
        url: 'https://sawit-net.com',
        email: 'layanan@netkrida.co.id',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Savana Cluster, A2, Jl. Karya Bakti',
          addressLocality: 'Pekanbaru',
          addressRegion: 'Riau',
          postalCode: '28282',
          addressCountry: 'ID'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 0.4798741,
          longitude: 101.4313303
        },
        openingHoursSpecification: [{
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '17:00'
        }, {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '08:00',
          closes: '12:00'
        }],
        priceRange: 'Enterprise',
        hasMap: 'https://www.google.com/maps/place/NETKRIDA+%7C+PT+NETKRIDA+TUAH+CAKRAWALA/@0.4798741,101.4287554,657m'
      });
    }
  }, [lang, page]);
  return null;
}